import { formatDate } from "utils/dateFormat";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import FilterButton from "components/FilterButton";
import { useStateContext } from "context/ContextProvider";
import ActivationBadgeType from "components/ActivationTypeBadge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faEye } from "@fortawesome/pro-solid-svg-icons";

const filters = [
    { text: "scadute", value: 0 },
    { text: "in scadenza 3 mesi", value: 3 },
    { text: "in scadenza 6 mesi", value: 6 },
];

const LicensesDetailTable = ({ data = [], absoluteFilters }) => {
    const navigate = useNavigate();
    const { getLicenses } = useStateContext();

    const [activeFilter, setActiveFilter] = useState(0);

    const isFirstRun = useRef(true);

    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }

        getLicenses(activeFilter, true);
    }, [activeFilter]);

    const navigateTo = (url) => {
        navigate(url);
    };

    const getDateColor = (date) => {
        if (!date) return "text-gray-600";

        const now = Date.now();
        const licenseDate = new Date(date);

        if (licenseDate < now) {
            return "text-red-600 font-medium";
        } else {
            return "text-gray-700";
        }
    };

    const isLicenseExpired = (date) => {
        if (!date) return false;

        const now = Date.now();
        const licenseDate = new Date(date);

        return licenseDate < now;
    };

    return (
        <div className="flex max-h-[27.75rem] flex-col gap-8 overflow-y-auto">
            <div className="flex flex-wrap justify-end gap-2">
                <div
                    className={`flex gap-2 self-end ${
                        absoluteFilters
                            ? "4xl:absolute 4xl:top-0 4xl:right-0 4xl:translate-y-[75%]"
                            : ""
                    }`}
                >
                    {filters.map(({ text, value }) => (
                        <FilterButton
                            key={value}
                            text={text}
                            isActive={value === activeFilter}
                            onChange={() => setActiveFilter(value)}
                        />
                    ))}
                </div>
            </div>

            <div className="overflow-x-auto">
                <table className="w-full border-collapse text-left">
                    <thead className="sticky top-0 left-0 z-10 bg-white/60 backdrop-blur-md">
                        <tr className="border-b border-gray-200/60 text-sm uppercase tracking-wider text-gray-600">
                            <th className="p-3 font-medium">Cliente</th>
                            <th className="p-3 font-medium">Piattaforma</th>
                            <th className="p-3 font-medium">Data Scadenza</th>
                            <th className="p-3 text-right font-medium">
                                Azione
                            </th>
                        </tr>
                    </thead>

                    <tbody className="text-gray-700">
                        {data.map((item, index) => (
                            <tr
                                key={index}
                                className="border-b border-gray-200/60 transition-colors hover:bg-gray-50"
                            >
                                <td className="p-3 text-sm font-medium">
                                    {item.customer}
                                </td>

                                <td className="p-3 text-sm">
                                    {<ActivationBadgeType text={item.type} />}
                                </td>

                                <td className="p-3 text-sm">
                                    {isLicenseExpired(item.expires_at) && (
                                        <FontAwesomeIcon
                                            className="mr-2 h-4 w-4 text-red-600"
                                            icon={faExclamationTriangle}
                                        />
                                    )}

                                    <span
                                        className={`${getDateColor(
                                            item.expires_at
                                        )}`}
                                    >
                                        {
                                            formatDate(item.expires_at).split(
                                                ","
                                            )[0]
                                        }
                                    </span>

                                    <br />

                                    {item.ssl_expires_at &&
                                        item.expires_at !==
                                            item.ssl_expires_at &&
                                        isLicenseExpired(
                                            item.ssl_expires_at
                                        ) && (
                                            <FontAwesomeIcon
                                                className="mr-2 h-4 w-4 text-red-600"
                                                icon={faExclamationTriangle}
                                            />
                                        )}

                                    {item.ssl_expires_at &&
                                        item.expires_at !==
                                            item.ssl_expires_at && (
                                            <span
                                                className={`${getDateColor(
                                                    item.ssl_expires_at
                                                )}`}
                                            >
                                                SSL:{" "}
                                                {
                                                    formatDate(
                                                        item.ssl_expires_at
                                                    ).split(",")[0]
                                                }
                                            </span>
                                        )}
                                </td>

                                <td className="p-3 text-right">
                                    {item.type !== "carrier" && (
                                        <button
                                            className="rounded-full bg-primary-500 px-2 py-1 transition hover:opacity-[85%]"
                                            onClick={() => {
                                                if (item.type === "onsite") {
                                                    navigateTo(
                                                        `/my/server/${item.code}`
                                                    );
                                                }
                                                if (item.type === "cloud") {
                                                    navigateTo(
                                                        `/my/domain/${item.name}`
                                                    );
                                                }
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                className="w-4 text-white"
                                                icon={faEye}
                                            />
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default LicensesDetailTable;
